// extracted by mini-css-extract-plugin
export default {"divider":"PYf2bOucoDR2HHk1t70g","vertical":"hqlsLXmNKFCGFaVNjuhv","horizontal":"xQxr_I4jucRNZp7ojoWV"};